import React from 'react';
import PolicyMessage from '~c/PolicyMessage';

class CheckPolicy extends React.Component {
  constructor(props) {
    super(props);
    const { checked = false } = props;

    this.state = {
      value: checked,
      isValid: true,
    };
  }

  validateCheck = () => {
    if(!this.state.value){
      this.setState({isValid: false});
    } else {
      this.setState({isValid: true});
    }
    return this.state.value;
  }

  render() {
    return (
      <div className="check registration__check">
        <label className="check__label">
          <input
            autoComplete="off"
            className="check__inp"
            type="checkbox"
            name="policy"
            required=""
            checked={this.state.value}
            onChange={(e) => this.setState({ value: e.target.checked })}
          />
          <span
            className={
              this.state.isValid || this.state.value ? 'check__box' : 'check__box check__box--error'
            }
          />
          <PolicyMessage />
        </label>
      </div>
    );
  }
}

export default CheckPolicy;
